import { PageNotFoundComponent } from './component/page-not-found/page-not-found.component';
import { SettingsComponent } from './component/settings/settings.component';
import { ActivitiesComponent } from './component/activities/activities.component';
import { PlansComponent } from './component/plans/plans.component';
import { SystemsComponent } from './component/systems/systems.component';
import { ProductsComponent } from './component/products/products.component';
import { CatalogComponent } from './component/catalog/catalog.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './component/login/login.component';
import { HomeComponent } from './component/home/home.component';
import { CanDeactivateService } from './service/can-deactivate.service';
import { SystemUpdateComponent } from './component/system-update/system-update.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { pageTitle: $localize`:@@pageTitle.signIn:Sign in` } },
  { path: 'home', component: HomeComponent, data: { breadcrumb:  $localize`:@@pageBreadCrumb.home:Home`, pageTitle: $localize`:@@pageTitle.home:Home`, helpContextId: 'syscm-home-so' } },
  {
    path: 'catalog',
    component: CatalogComponent,
    data: { breadcrumb: $localize`:@@pageBreadCrumb.catalog:Catalog`, url: '/catalog/overview', helpContextId: 'syscm-prodcat-so' },
    loadChildren: () => import('./component/catalog/catalog.module').then(m => m.CatalogModule)
  }, 
  { path: 'products',
    component: ProductsComponent,
    data: { breadcrumb: $localize`:@@pageBreadCrumb.products:Products`, url: '/products/overview', helpContextId: 'syscm-prodpg-bg'},
    loadChildren: () => import('./component/products/product.module').then(m => m.ProductModule)
  },
  {
    path: 'systems',
    component: SystemsComponent,
    data: { breadcrumb: $localize`:@@pageBreadCrumb.systems:Systems`, url: '/systems/overview', helpContextId: 'syscm-sysovw-so' },
    loadChildren: () => import('./component/systems/systems.module').then(m => m.SystemsModule)
  },
  {
    path: 'plans',
    component: PlansComponent,
    data: { breadcrumb: $localize`:@@pageBreadCrumb.plans:Plans`, url: '/plans/overview', helpContextId: 'syscm-plan-so' },
    loadChildren: () => import('./component/plans/plans.module').then(m => m.PlansModule)
  },
  {
    path: 'activities',
    component: ActivitiesComponent,
    data: { breadcrumb:  $localize`:@@pageBreadCrumb.activities:Activities`, url: '/activities/overview', helpContextId: 'syscm-actvty-ovw-so' },
    loadChildren: () => import('./component/activities/activities.module').then(m => m.ActivitiesModule)
  },
  {
    path: 'settings',
    component: SettingsComponent,
    data: { breadcrumb: $localize`:@@pageBreadCrumb.settings:Settings`, helpContextId: 'syscm-set-gen-so' },
    loadChildren: () => import('./component/settings/settings.module').then(m => m.SettingsModule)
  },
  {
    path: 'update',
    component: SystemUpdateComponent,
    data: { breadcrumb: $localize`:@@pageBreadCrumb.update:Update`, url: '/update', pageTitle: $localize`:@@pageTitle.systemUpdate:System Update`, helpContextId: 'syscm-updscm-so' },
    canDeactivate: [CanDeactivateService]
  },
  {
    path: '404',
    component: PageNotFoundComponent,
    data: { url: '/404', pageTitle: $localize`:@@pageTitle.404:Page not found`}
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
